module.exports = __webpack_public_path__ + "img/ring_g_e_null_null@3x.49307063.png";